import HorizontalBarChart from './horizontal-bar-chart';
import './styles.styl';

export default HorizontalBarChart;
